/**
 * What to do when this phone leaves the championship camera screen.
 *
 * A phone that was filming a table stops its own recorder and is removed
 * from that table. The table recording session ends when no other online
 * camera is still on the table.
 */
export function planCameraLeave({
  cameras,
  isThisPhone,
  recording = false,
  tableRecording = null,
}) {
  const list = Array.isArray(cameras) ? cameras : [];
  const mine = list.find((cam) => isThisPhone?.(cam));
  if (!mine) {
    return {
      release: false,
      stopTable: false,
      table: null,
      stopLocal: Boolean(recording),
    };
  }

  const table = Number(mine.table_number);
  const roomOnTable =
    tableRecording != null &&
    Number(tableRecording.table_number) === table;
  const filming = Boolean(recording) || roomOnTable;
  if (!filming || !Number.isFinite(table) || table < 1) {
    return { release: false, stopTable: false, table, stopLocal: false };
  }

  const othersOnline = list.filter((cam) => {
    if (Number(cam?.table_number) !== table) return false;
    if (isThisPhone(cam)) return false;
    return Boolean(cam?.online || cam?.socket_id);
  });

  return {
    release: true,
    stopTable: othersOnline.length === 0,
    table,
    stopLocal: Boolean(recording),
  };
}
